module.exports = __webpack_public_path__ + "img/article_ripple_opt.5a2de0b3.png";